exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".list-freememo.v-list--disabled h2,.list-reservations.v-list--disabled h2{color:rgba(0,0,0,.2)}", ""]);
